<template>
  <section class="card invoice-preview-wrapper">
    <b-card no-body class="invoice-preview-card full-height d-flex justify-content-between">
      <div>
        <b-badge
            v-if="userEvaluation"
            :variant="isEvaluationValid ? 'primary' : 'warning'"
            class="badge-glow w-100"
        >
          {{ isEvaluationValid ? 'Validé' : 'Non Validé' }}
        </b-badge>

        <div class="m-2">
          <div v-if="userEvaluation">
            <app-timeline>
              <app-timeline-item
                  v-for="(item, index) in signatureValidUser"
                  :key="index"
                  :title="`${item.titre} ${item.users.lastName} ${item.users.firstName}`"
                  :subtitle="item.text"
                  :time="formatDate(item.dateCreate)"
                  :variant="item.variant"
              />
            </app-timeline>
          </div>
          <div v-else class="alert-body">
            <b-alert variant="warning" show>
              <span><strong>Pas d'évaluation effectuée pour l'année {{ currentYear || new Date().getFullYear() }} !</strong></span>
            </b-alert>
          </div>
        </div>
      </div>
    </b-card>
  </section>
</template>

<script>
import { BBadge, BCard, BAlert } from 'bootstrap-vue';
import AppTimeline from '@core/components/app-timeline/AppTimeline.vue';
import AppTimelineItem from '@core/components/app-timeline/AppTimelineItem.vue';
import Ripple from 'vue-ripple-directive';
import moment from 'moment';

export default {
  directives: { Ripple },
  components: { BCard, BBadge, BAlert, AppTimeline, AppTimelineItem },
  props: {
    userData: { type: Object, required: true },
    userEvaluation: { type: Object, default: null },
    currentYear: { type: Number, default: null },
    signatureValidUser: { type: Array, default: () => [] },
  },
  data() {
    return {
      // signatureValidUser: [],
      years: [],
    };
  },
  computed: {
    isEvaluationValid() {
      return this.userEvaluation && this.userEvaluation.valid;
    },
  },
  watch: {
    userEvaluation: {
      immediate: true,
      deep: true,
      handler() {
        // this.processUserEvaluation();
      },
    },
    signatureValidUser: {
      handler() {
      },
      deep: true
    }
  },
  methods: {
    formatDate(date) {
      if (!date) return '';
      if (Array.isArray(date)) {
        const [year, month, day] = date;
        return `${day.toString().padStart(2, '0')}-${month.toString().padStart(2, '0')}-${year}`;
      }
      if (typeof date === 'string') {
        const [year, month, day] = date.split('-');
        return `${day}-${month}-${year}`;
      }
      return '';
    },


  },
  mounted() {
    // this.processUserEvaluation();
  },
};
</script>
